const roundTwoDecimals = (value: number): number => {
  return Math.round(value * 100) / 100;
};

export default roundTwoDecimals;
